import React from 'react';
import {
  Card, Typography, Box, CardContent, Grid, Divider,
} from '@material-ui/core';
import { useLocation } from 'react-router-dom';
import RepairProperty from './RepairProperty';
import type { IRepairItem } from '../marking/MarkingInterfaces';

const RepairCard: React.FC<{ RepairItem:IRepairItem, showExtraProps?:boolean }> = ({ RepairItem, showExtraProps = false }) => {
  const location = useLocation();

  const figureOutTitle = () => {
    if (location.pathname.includes('jeweler') || location.pathname.includes('engraver')) {
      return 'Measurements';
    } if (RepairItem?.repairItemType?.label === 'Watch') {
      return 'Marking Information';
    }
    return 'Repair Information';
  };

  return (
    <Card style={{ width: '100%' }}>
      <Grid container justifyContent="space-between">
        <Grid item>
          <Box ml={2} my={2}>
            <Typography variant="h5" style={{ fontSize: '1.125rem' }}>{ figureOutTitle() }</Typography>
          </Box>
        </Grid>
        <Grid item>
          <Box mr={2} mt={2.5}>
            <Typography variant="h5" style={{ fontSize: '.875rem', color: '#A5A5A5', textTransform: 'uppercase' }}>{`${typeof RepairItem.label === 'string' ? RepairItem.label : ''}`}</Typography>
          </Box>
        </Grid>
      </Grid>
      <Divider />
      <CardContent>
        <Grid
          container
          spacing={2}
        >
          { Boolean(RepairItem.thickness)
            && (
            <Grid item lg={4} md={6} xs={12}>
              <RepairProperty
                title={RepairItem.thickness}
                subtitle="Thickness (mm)"
              />
            </Grid>
            )}
          { Boolean(RepairItem.width)
            && (
            <Grid item lg={4} md={6} xs={12}>
              <RepairProperty
                title={RepairItem.width}
                subtitle="Width (mm)"
              />
            </Grid>
            )}
          { Boolean(RepairItem.size)
            && (
            <Grid item lg={4} md={6} xs={12}>
              <RepairProperty
                title={RepairItem.size.label}
                subtitle="Ring Size"
              />
            </Grid>
            )}
          {
            (typeof RepairItem.sizeChange === 'number')
            && (
            <Grid item lg={4} md={6} xs={12}>
              <RepairProperty
                title={RepairItem.sizeChange}
                subtitle="Size Change"
              />
            </Grid>
            )
            }
          {(typeof RepairItem?.stamped?.label === 'string')
              && (
              <Grid item lg={4} md={6} xs={12}>
                <RepairProperty
                  title={RepairItem?.stamped?.label}
                  subtitle="Stamped"
                />
              </Grid>
              )}
          {(typeof RepairItem?.metalType?.label === 'string')
              && (
              <Grid item lg={4} md={6} xs={12}>
                <RepairProperty
                  title={RepairItem?.metalType?.label}
                  subtitle="Metal Type"
                />
              </Grid>
              )}
          {(typeof RepairItem?.stoneType?.label === 'string')
              && (
              <Grid item lg={4} md={6} xs={12}>
                <RepairProperty
                  title={RepairItem?.stoneType?.label}
                  subtitle="Stone Type"
                />
              </Grid>
              )}
          {(showExtraProps && typeof RepairItem?.manufacturer?.label === 'string')
          && (
            <Grid item lg={4} md={6} xs={12}>
              <RepairProperty
                title={RepairItem?.manufacturer.label}
                subtitle="Manufacturer"
              />
            </Grid>
          )}
          {(showExtraProps && typeof RepairItem?.brand?.label === 'string')
          && (
            <Grid item lg={4} md={6} xs={12}>
              <RepairProperty
                title={RepairItem?.brand.label}
                subtitle="Brand"
              />
            </Grid>
          )}
          {(showExtraProps && typeof RepairItem?.serialNumber === 'string')
          && (
            <Grid item lg={4} md={6} xs={12}>
              <RepairProperty
                title={RepairItem?.serialNumber}
                subtitle="Serial Number"
              />
            </Grid>
          )}
          {(showExtraProps && typeof RepairItem?.modelNumber === 'string')
          && (
            <Grid item lg={4} md={6} xs={12}>
              <RepairProperty
                title={RepairItem?.modelNumber}
                subtitle="Model Number"
              />
            </Grid>
          )}
          {(showExtraProps && typeof RepairItem?.caseNumber === 'string')
          && (
            <Grid item lg={4} md={6} xs={12}>
              <RepairProperty
                title={RepairItem?.caseNumber}
                subtitle="Case Number"
              />
            </Grid>
          )}
          {(showExtraProps && typeof RepairItem?.sku === 'string')
          && (
            <Grid item lg={4} md={6} xs={12}>
              <RepairProperty
                title={RepairItem?.sku}
                subtitle="SKU"
              />
            </Grid>
          )}
          {(showExtraProps && typeof RepairItem?.tagNumber === 'string')
          && (
            <Grid item lg={4} md={6} xs={12}>
              <RepairProperty
                title={RepairItem?.tagNumber}
                subtitle="Tag Number"
              />
            </Grid>
          )}

        </Grid>
      </CardContent>

    </Card>
  );
};

export default RepairCard;
